module.exports = __webpack_public_path__ + "img/268.7a8458ac.jpg";